import styles from './loader.module.scss'
import logoLightSVG from '../../assets/logo.svg'
import logoDarkSVG from '../../assets/logo-dark.svg'
import classNames from 'classnames'
import type { LoaderTheme } from '../../../../trillion-viewer/src/viewer/types/loader-theme'

interface ILoaderComponent {
  progress?: number
  showBackground: boolean
  background?: string
  disableLogo?: boolean
  loaderTheme?: LoaderTheme | null
  showAnimation?: boolean
}

export function LoaderComponent({
  progress,
  showBackground,
  background,
  disableLogo,
  loaderTheme,
  showAnimation,
}: ILoaderComponent) {

  const isLightOnDark = (loaderTheme ?? 'lightOnDark') === 'lightOnDark';
  const loaderColor = isLightOnDark ? 'light' : 'dark';
  const backgroundColor = showBackground ? isLightOnDark ? 'dark' : 'light' : 'transparent';
  const logoSVG = isLightOnDark ? logoLightSVG : logoDarkSVG;

  return (
    <div
      className={classNames(styles.loading__screen_wrap, {[styles[`background-${backgroundColor}`]]: true})}
      style={{background: `${background}`}}
    >
      <div className={styles.content__wrap}>
        {!disableLogo && <img
          src={logoSVG}
          alt="loading..."
          className={styles.loading__logo}
        />}
        <div className={styles.loading__screen} id="loading__lottie-wrap">
          <div className={classNames(styles.loading, {[styles[`color-${loaderColor}`]]: true})}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
          </div>
        </div>
        <div className={classNames(styles.progressPercents, {[styles[`color-${loaderColor}`]]: true})}>
          {progress !==  undefined ? (
            (progress * 100).toFixed() + '%'
          ) : (
            <div className={classNames(styles.progress__text, {[styles[`color-${loaderColor}`]]: true})}>Initializing...</div>
          )}
        </div>
        <div className={classNames(styles.loading__text, {[styles[`color-${loaderColor}`]]: true})}>
          {showAnimation ? (
            'Loading...'
            ) : (
            'Please wait'
          )}
        </div>
      </div>
    </div>
  );
}

export default LoaderComponent
